<script setup lang="ts">
import useCustomerConversation from "@/customer/composables/conversation/useCustomerConversation";
import ConversationTimeline from "@/conversation/components/ConversationTimeline.vue";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {computed, nextTick, ref, watch} from "vue";

const props = defineProps<{
    customerId: number;
}>();

const scrollable = ref<HTMLElement | null>(null);

const {messages, isLoading, isLoadingMore, hasMore, loadMore} = useCustomerConversation(props.customerId);

const isEmpty = computed(() => {
    return !isLoading.value && messages.value.length === 0;
});

watch(isLoading, (loading) => {
    if (loading || messages.value.length === 0) {
        return;
    }

    nextTick(() => {
        if (scrollable.value) {
            scrollable.value.scrollTop = scrollable.value.scrollHeight;
        }
    });
});
</script>

<template>
  <div ref="scrollable" class="flex-1 overflow-y-auto bg-slate-50 pb-4">
    <BaseFlexSpinner v-if="isLoading" class="py-8" />
    <div v-else-if="isEmpty" class="p-4 text-sm text-gray-500 text-center">
      Aucune conversation trouvée.
    </div>
    <div v-else class="flex flex-col">
      <div class="flex justify-center p-2">
        <BaseButton
          v-if="hasMore()"
          :loading="isLoadingMore"
          density="comfortable"
          variant="text"
          @click="loadMore"
        >
          Charger les messages précédents
        </BaseButton>
      </div>
      <ConversationTimeline :messages="messages" />
    </div>
  </div>
</template>
